<template>
	<header class="header">
		<Nav></Nav>
		<div class="content">
			<h3>高效·省心的APP定制开发团队</h3>
			<p>免费维护&nbsp | &nbsp 专属定制 &nbsp | &nbsp 一对一服务</p>
			<!-- <button @click="toConsult">APP需求免费评估</button> -->
			<a href="https://wt.zoosnet.net/LR/Chatpre.aspx?id=LRW51906172&lng=cn" target="_blank">APP需求免费评估</a>
		</div>
		<div class="ability">
			<div :class="{'ability-box':active==1}" @mouseover="mouseoverBox(1)">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/100.png" alt="" />
				<p>百人技术团队</p>
			</div>
			<div :class="{'ability-box':active==2}" @mouseover="mouseoverBox(2)">
				<img src="../assets/15.png" alt="" />
				<p>15年定制经验</p>
			</div>
			<div :class="{'ability-box':active==3}" @mouseover="mouseoverBox(3)">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/500.png" alt="" />
				<p>500强企业放心之选</p>
			</div>
			<div :class="{'ability-box':active==4}" @mouseover="mouseoverBox(4)">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/3.png" alt="" />
				<p>3地协同办公</p>
			</div>
		</div>
	</header>
	<div class="service">
		<h3>专业UED团队，根据企业属性，量身定制APP</h3>
		<div class="dianshang" @mouseenter="mouseOver(1)" @mouseleave="mouseLeave">
			<h5>电商APP</h5>
			<div class="lable-box">
				<div class="lable">B2B</div>
				<div class="lable">B2C</div>
				<div class="lable">C2B</div>
			</div>
			<img v-if="isLogoShow && index == 1"
				src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/shangcheng01.png" alt="" />
			<img v-else src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/shangcheng02.png" alt="" />
		</div>
		<div class="jiaoyu" @mouseenter="mouseOver(2)" @mouseleave="mouseLeave">
			<h5>教育APP</h5>
			<div class="lable-box">
				<div class="lable">早教</div>
				<div class="lable">解题</div>
				<div class="lable">考试</div>
				<div class="lable">视频</div>
				<div class="lable">更多</div>
			</div>
			<img v-if="isLogoShow && index == 2"
				src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/jiaoyu01.png" alt="" />
			<img v-else src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/jiaoyu02.png" alt="" />
		</div>
		<div class="qiye" @mouseenter="mouseOver(3)" @mouseleave="mouseLeave">
			<h5>企业应用APP</h5>
			<div class="lable-box">
				<div class="lable">OA</div>
				<div class="lable">CRM</div>
				<div class="lable">ERP</div>
				<div class="lable">更多</div>
			</div>
			<img v-if="isLogoShow && index == 3"
				src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/qiye01.png" alt="" />
			<img v-else src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/qiye02.png" alt="" />
		</div>
		<div class="o2o" @mouseenter="mouseOver(4)" @mouseleave="mouseLeave">
			<h5>O2O</h5>
			<div class="lable-box">
				<div class="lable">生鲜</div>
				<div class="lable">餐饮</div>
				<div class="lable">同城</div>
			</div>
			<img v-if="isLogoShow && index == 4"
				src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/O2O01.png" alt="" />
			<img v-else src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/O2O02.png" alt="" />
		</div>
		<div class="zhibo" @mouseenter="mouseOver(5)" @mouseleave="mouseLeave">
			<h5>直播APP</h5>
			<div class="lable-box">
				<div class="lable">带货</div>
				<div class="lable">娱乐</div>
				<div class="lable">教育</div>
				<div class="lable">更多</div>
			</div>
			<img v-if="isLogoShow && index == 5"
				src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/zhibo01.png" alt="" />
			<img v-else src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/zhibo02.png" alt="" />
		</div>
		<div class="shejiao" @mouseenter="mouseOver(6)" @mouseleave="mouseLeave">
			<h5>社交APP</h5>
			<div class="lable-box">
				<div class="lable">社群</div>
				<div class="lable">C2C</div>
				<div class="lable">更多</div>
			</div>
			<img v-if="isLogoShow && index == 6"
				src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/shejiao01.png" alt="" />
			<img v-else src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/shejiao02.png" alt="" />
		</div>
		<div class="more" @mouseenter="mouseOver(7)" @mouseleave="mouseLeave">
			<h5>更多APP定制</h5>
			<div class="lable-box">
				<div class="lable" @click="toCases" style="width: 83px">了解更多</div>
			</div>
			<img v-if="isLogoShow && index == 7"
				src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/gengduo01.png" alt="" />
			<img v-else src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/gengduo02.png" alt="" />
		</div>
	</div>
	<div class="scheme">
		<h3>多行业成熟应用解决方案</h3>
		<div class="box">
			<div class="content" ref="Box" @mousewheel="scroll">
				<!-- swiper -->
				<div class="swiper-container">
					<div class="swiper-wrapper">
						<div class="swiper-slide">
							<div class="ban1" :class="{'fangda':lj==1}" @mouseover="mouseoverlj(1)"
								@mouseleave="mouseLeavelj">
								<div class="zhezhao"></div>
								<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/zhengfu.png"
									alt="" />
								<p>政府&大企业</p>
								<a style="font-size: 0.2rem;color: #FFFFFF;z-index: 999;cursor: pointer;" v-if="lj==1"
									href="https://wt.zoosnet.net/LR/Chatpre.aspx?id=LRW51906172&lng=cn"
									target="_blank">了解详情 &nbsp ></a>
							</div>
						</div>
						<div class="swiper-slide">
							<div class="ban2" :class="{'fangda':lj==2}" @mouseover="mouseoverlj(2)"
								@mouseleave="mouseLeavelj">
								<div class="zhezhao"></div>
								<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/yiliao.png"
									alt="" />
								<p>医疗</p>
								<a style="font-size: 0.2rem;color: #FFFFFF;z-index: 999;cursor: pointer;" v-if="lj==2"
									href="https://wt.zoosnet.net/LR/Chatpre.aspx?id=LRW51906172&lng=cn"
									target="_blank">了解详情 &nbsp ></a>
							</div>
						</div>
						<div class="swiper-slide">
							<div class="ban3" :class="{'fangda':lj==3}" @mouseover="mouseoverlj(3)"
								@mouseleave="mouseLeavelj">
								<div class="zhezhao"></div>
								<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/dianshang.png"
									alt="" />
								<p>电商</p>
								<a style="font-size: 0.2rem;color: #FFFFFF;z-index: 999;cursor: pointer;" v-if="lj==3"
									href="https://wt.zoosnet.net/LR/Chatpre.aspx?id=LRW51906172&lng=cn"
									target="_blank">了解详情 &nbsp ></a>
							</div>
						</div>
						<div class="swiper-slide">
							<div class="ban4" :class="{'fangda':lj==4}" @mouseover="mouseoverlj(4)"
								@mouseleave="mouseLeavelj">
								<div class="zhezhao"></div>
								<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/dichan.png"
									alt="" />
								<p>地产</p>
								<a style="font-size: 0.2rem;color: #FFFFFF;z-index: 999;cursor: pointer;" v-if="lj==4"
									href="https://wt.zoosnet.net/LR/Chatpre.aspx?id=LRW51906172&lng=cn"
									target="_blank">了解详情 &nbsp ></a>
							</div>
						</div>
						<div class="swiper-slide">
							<div class="ban5" :class="{'fangda':lj==5}" @mouseover="mouseoverlj(5)"
								@mouseleave="mouseLeavelj">
								<div class="zhezhao"></div>
								<img src="../assets/img/hangye/can.png" alt="" />
								<p>餐饮</p>
								<a style="font-size: 0.2rem;color: #FFFFFF;z-index: 999;cursor: pointer;" v-if="lj==5"
									href="https://wt.zoosnet.net/LR/Chatpre.aspx?id=LRW51906172&lng=cn"
									target="_blank">了解详情 &nbsp ></a>
							</div>
						</div>
						<div class="swiper-slide">
							<div class="ban6" :class="{'fangda':lj==6}" @mouseover="mouseoverlj(6)"
								@mouseleave="mouseLeavelj">
								<div class="zhezhao"></div>
								<img src="../assets/img/hangye/nong.png" alt="" />
								<p>农业</p>
								<a style="font-size: 0.2rem;color: #FFFFFF;z-index: 999;cursor: pointer;" v-if="lj==6"
									href="https://wt.zoosnet.net/LR/Chatpre.aspx?id=LRW51906172&lng=cn"
									target="_blank">了解详情 &nbsp ></a>
							</div>
						</div>
						<div class="swiper-slide">
							<div class="ban7" :class="{'fangda':lj==7}" @mouseover="mouseoverlj(7)"
								@mouseleave="mouseLeavelj">
								<div class="zhezhao"></div>
								<img src="../assets/img/hangye/jiao.png" alt="" />
								<p>教育</p>
								<a style="font-size: 0.2rem;color: #FFFFFF;z-index: 999;cursor: pointer;" v-if="lj==7"
									href="https://wt.zoosnet.net/LR/Chatpre.aspx?id=LRW51906172&lng=cn"
									target="_blank">了解详情 &nbsp ></a>
							</div>
						</div>
						<div class="swiper-slide">
							<div class="ban8" :class="{'fangda':lj==8}" @mouseover="mouseoverlj(8)"
								@mouseleave="mouseLeavelj">
								<div class="zhezhao"></div>
								<img src="../assets/img/hangye/fu.png" alt="" />
								<p>服务</p>
								<a style="font-size: 0.2rem;color: #FFFFFF;z-index: 999;cursor: pointer;" v-if="lj==8"
									href="https://wt.zoosnet.net/LR/Chatpre.aspx?id=LRW51906172&lng=cn"
									target="_blank">了解详情 &nbsp ></a>
							</div>
						</div>
					</div>

					<!-- 如果需要导航按钮 -->
					<div class="swiper-button-prev"></div>
					<div class="swiper-button-next"></div>
				</div>
			</div>
		</div>
	</div>
	<div class="team">
		<h3>专业软件定制团队，更值得信赖</h3>
		<div class="content">
			<div class="nengli">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/nengli.png" alt="" />
				<!-- <h5>服务能力广泛</h5>
				<p>十余年开发经验,数千项案例，业务能力辐射全行业</p> -->
				<h5>逾期即赔付</h5>
				<p>我们严格把控工期不仅承诺如此，如果做不到按时交付，逾期即赔付</p>
			</div>
			<div class="biaozhun">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/biaozhun.png" alt="" />
				<h5>项目整包</h5>
				<p>设计、开发、上架整包，专业项目经理全程督导跟进</p>
			</div>
			<div class="chengben">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/chengben.png" alt="" />
				<h5>快速/低成本</h5>
				<p>多年技术经验沉淀，功能模块成熟，开发更快、成本更低</p>
			</div>
			<div class="weihu">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/weihu.png" alt="" />
				<h5>终身免费质保</h5>
				<p>提供免费运维质保，省去运营后顾之忧</p>
			</div>
		</div>
	</div>
	<div class="case">
		<div class="anli">
			<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/app1.png" alt="" />
			<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/app2.png" alt="" />
			<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/app3.png" alt="" />
			<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/app4.png" alt="" />
			<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/app5.png" alt="" />
		</div>
		<div class="content">
			<h3>各行业场景化应用案例</h3>
			<p>
				<!-- APICoid -->帮助用户在移动场景中快速落地，覆盖
				电商丶O2O丶社交丶教育等众多领域
			</p>
			<button @click="toMore">更多行业化案例</button>
		</div>
	</div>
	<div class="serve">
		<h3>上千企业的放心之选</h3>
		<p>同追求极致的机构合作，创造有影响力的产品</p>
		<div class="content">
			<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/bg1.png" alt="" class="bg" />
			<div class="dingzhi">
				<h3>APP定制服务</h3>
				<p>企业移动信息化转型，互联网创业快速落地</p>
				<!-- <h5>400-039-7699</h5> -->
				<h5>15617622505</h5>
			</div>
		</div>
	</div>
	<div class="typepilot">
		<h3>一键开启云创增长新空间</h3>
		<p>专业的解决方案、先进的产品帮您实现业务的快速增长</p>
		<!-- <button @click="toConsult">立即咨询</button> -->
		<a href="https://wt.zoosnet.net/LR/Chatpre.aspx?id=LRW51906172&lng=cn" target="_blank">立即咨询</a>
	</div>
	<Footer></Footer>
	<Floating></Floating>
	<Onlineservice></Onlineservice>
</template>

<script>
	import "swiper/dist/js/swiper";
	import "swiper/dist/css/swiper.css";
	import Swiper from "swiper";
	import Nav from "./Nav.vue";
	import Footer from "./Footer.vue";
	import Floating from "./Floating.vue";
	import Onlineservice from "./Onlineservice.vue";

	export default {
		name: "HelloWorld",
		components: {
			Nav,
			Footer,
			Floating,
			Onlineservice,
		},
		data() {
			return {
				isLogoShow: false,
				index: 0,
				lj: 0,
				active: 2,
			};
		},

		mounted() {
			this.$refs.Box.addEventListener("scroll", this.scroll);
			new Swiper(".swiper-container", {
				//direction: 'vertical', // 垂直切换选项
				//mousewheel: true, //滚轮
				// autoplay: { //自动开始
				// 	delay: 2500, //时间间隔
				// 	disableOnInteraction: false, //*手动操作轮播图后不会暂停*
				// },
				loop: false, // 循环模式选项
				//  一行显示多个
				slidesPerView: 4,
				// 4个为一组
				slidesPerGroup: 1,

				// 如果需要分页器
				// pagination: {
				// 	el: '.swiper-pagination',
				// 	clickable: true, // 分页器可以点击
				// },

				// 如果需要前进后退按钮
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},

				// 如果需要滚动条
				// scrollbar: {
				// 	el: '.swiper-scrollbar',
				// },
			});
		},
		methods: {
			mouseoverBox(e) {
				this.active = e;
			},
			toMore() {
				this.$router.push("/shapp/case");

			},
			// toConsult() {
			// 	window.open(
			// 		"https://wt.zoosnet.net/LR/Chatpre.aspx?id=LRW51906172&lng=cn&e=%e5%bc%b9%e7%aa%97",
			// 		"_blank"
			// 	);
			// },
			mouseoverlj(index) {
				this.lj = index
			},
			mouseLeavelj() {
				this.lj = 0
			},
			mouseOver(index) {
				this.isLogoShow = true;
				this.index = index;
			},
			mouseLeave() {
				this.isLogoShow = false;
			},

			toLeft() {
				this.$refs.Box.scrollLeft -= 360;
			},
			toRight() {
				this.$refs.Box.scrollLeft += 360;
				console.log(this.$refs.Box.scrollLeft);
			},
			toCases() {
				window.open("https://www.junhebrand.com/cases", "_blank");
			},
		},
	};
</script>

<style lang="less" scoped>
	html {
		font-size: 60px !important;
	}

	// 1.50416
	.header {
		width: 100%;
		height: 650px;
		background: url(../assets/img/appbj.jpg) no-repeat;
		background-size: cover;

		.content {
			width: 1440px;
			height: 400px;
			margin: 0 auto;
			/* background-color: white; */
			overflow: hidden;
			color: white;

			h3 {
				height: 50px;
				line-height: 50px;
				font-size: 36px;
				margin-top: 100px;
				font-weight: 540;
			}

			p {
				height: 50px;
				line-height: 50px;
				font-size: 22px;
				margin-top: 20px;
				font-weight: 400;
			}

			a {
				display: block;
				width: 180px;
				height: 50px;
				margin-top: 40px;
				background: #fe0000;
				box-shadow: 0px 8px 32px 0px rgba(254, 0, 0, 0.16);
				border-radius: 25px;
				font-size: 16px;
				color: white;
				text-align: center;
				line-height: 50px;
			}
		}

		.ability {
			width: 1440px;
			height: 100px;
			margin: 0 auto;
			margin-top: 100px;

			div {
				display: flex;
				align-items: center;
				width: 250px;
				height: 100px;
				background-color: #f2f4fa;
				float: left;
				margin: 0 10px;
				transition: transform 0.5s;
				border-radius: 3px;
				box-shadow: 2px 2px 10px 2px #08080812;
			}

			div:nth-child(1)>img,
			div:nth-child(3)>img {
				width: 60px;
				height: 30px;
				display: block;
				margin: 0 15px 0 20px;
			}

			div:nth-child(2)>img,
			div:nth-child(4)>img {
				width: 60px;
				height: 30px;
				display: block;
			}

			// div:hover {
			// 	box-shadow: 2px 2px 2px 6px #fe000010;
			// 	border-bottom: 2px solid #fe0000;
			// 	transform: translateY(-10px);
			// }

			// .ability-box1:hover~.ability-box2 {
			// 	box-shadow: 2px 2px 10px 2px #08080812;
			// 	border-bottom: none;
			// 	transform: translateY(0px);
			// }

			.ability-box {
				box-shadow: 2px 2px 2px 6px #fe000010;
				border-bottom: 2px solid #fe0000;
				transform: translateY(-10px);
			}

			p {
				height: 100px;
				line-height: 100px;
				font-size: 16px;
				font-weight: 500;
				color: #000000;
			}
		}
	}

	.service {
		width: 1440px;
		height: 820px;
		margin: 0 auto;
		// background-color: blue;
		margin-top: 60px;
		overflow: hidden;

		img {
			display: block;
			width: 100px;
			height: 100px;
		}

		h3 {
			width: 1000px;
			text-align: center;
			height: 50px;
			margin: 20px auto;
			font-size: 36px;
			font-weight: 500;
			color: #000000;
			line-height: 50px;
			margin-top: 50px;
		}

		.dianshang {
			position: relative;
			width: 390px;
			height: 250px;
		}

		.jiaoyu {
			position: relative;
			width: 390px;
			height: 250px;
		}

		.qiye {
			position: relative;
			width: 530px;
			height: 250px;
			float: left;
		}

		.shejiao {
			position: relative;
			width: 290px;
			height: 250px;
		}

		.more {
			width: 210px;
		}
	}

	.service>div {
		position: relative;
		transition: all 0.5s;
	}

	.service>div>img {
		position: absolute;
		bottom: 10px;
		right: 10px;
	}

	.service>div:hover {
		box-shadow: 8px 8px 5px 5px rgba(255, 162, 145, 0.2);
		background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/teamBg.png) no-repeat;
		background-size: cover;
		background-color: #f0f3fa;
		transform: translateX(-5px) translateY(-5px);

		h5 {
			color: #ffffff !important;
			font-weight: 500 !important;
		}

		.lable-box .lable {
			background-color: rgba(246, 245, 244, 0.4) !important;
			color: #ffffff !important;
		}
	}

	.scheme {
		width: 100%;
		height: 720px;
		background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/schemeBg.png) no-repeat;
		background-size: cover;
		overflow: hidden;

		h3 {
			width: 1440px;
			height: 100px;
			line-height: 100px;
			margin: 30px auto;
			text-align: center;
			font-size: 36px;
			font-weight: 500;
			color: #ffffff;
		}

		.box {
			position: relative;
			overflow: hidden;
			width: 1440px;
			height: 560px;
			margin: 0 auto;
			display: flex;

			.swiper-container {
				width: 100%;
				height: 100%;

				.swiper-button-prev {
					width: 20px;
					height: 20px;

					background-size: 20px 20px;
					background-image: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/btn_l.png);
				}

				.swiper-button-next {
					width: 20px;
					height: 20px;
					margin-right: 0px;
					background-size: 20px 20px;
					background-image: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/jiantouright.png);
				}

				.swiper-wrapper {
					width: 100%;
					height: 100%;
					margin-top: -220px;

					.swiper-slide {
						width: 360px;
						height: 540px;

						div {
							width: 100%;
							height: 100%;

							img {
								position: relative;
								display: block;
								width: 68px;
								height: 68px;
								top: 210px;
							}

							p {
								position: relative;
								font-size: 26px;
								font-weight: 500;
								color: #ffffff;
								top: 210px;
							}

							a {
								position: relative;
								font-size: 14px;
								font-weight: 400;
								color: #ffffff;
								line-height: 58px;
								top: 210px;
							}
						}

						.fangda {
							transform: scale(1.1);
							transition: all .5s;
						}

						.ban1 {
							background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/ban4.png) no-repeat;
							background-size: cover;

							.zhezhao {
								position: absolute;
								width: 100%;
								height: 100%;
								background-color: #00000036;
							}

							.zhezhao:hover {
								z-index: 99;
								background-color: transparent;
							}
						}

						.ban2 {
							background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/ban3.png) no-repeat;
							background-size: cover;

							.zhezhao {
								position: absolute;
								width: 100%;
								height: 100%;
								background-color: #00000036;
							}

							.zhezhao:hover {
								z-index: 99;
								background-color: transparent;
							}

							a {
								z-index: 999;
							}
						}

						.ban3 {
							background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/ban2.png) no-repeat;
							background-size: cover;

							.zhezhao {
								position: absolute;
								width: 100%;
								height: 100%;
								background-color: #00000036;
							}

							.zhezhao:hover {
								z-index: 99;
								background-color: transparent;
							}
						}

						.ban4 {
							background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/ban1.png) no-repeat;
							background-size: cover;

							.zhezhao {
								position: absolute;
								width: 100%;
								height: 100%;
								background-color: #00000036;
							}

							.zhezhao:hover {
								z-index: 99;
								background-color: transparent;
							}
						}

						.ban5 {
							background: url(../assets/img/hangye/canyin.png) no-repeat;
							background-size: cover;

							.zhezhao {
								position: absolute;
								width: 100%;
								height: 100%;
								background-color: #00000036;
							}

							.zhezhao:hover {
								z-index: 99;
								background-color: transparent;
							}
						}

						.ban6 {
							background: url(../assets/img/hangye/nongye.png) no-repeat;
							background-size: cover;

							.zhezhao {
								position: absolute;
								width: 100%;
								height: 100%;
								background-color: #00000036;
							}

							.zhezhao:hover {
								z-index: 99;
								background-color: transparent;
							}
						}

						.ban7 {
							background: url(../assets/img/hangye/jiaoyu.png) no-repeat;
							background-size: cover;

							.zhezhao {
								position: absolute;
								width: 100%;
								height: 100%;
								background-color: #00000036;
							}

							.zhezhao:hover {
								z-index: 99;
								background-color: transparent;
							}
						}

						.ban8 {
							background: url(../assets/img/hangye/fuwu.png) no-repeat;
							background-size: cover;

							.zhezhao {
								position: absolute;
								width: 100%;
								height: 100%;
								background-color: #00000040;
							}

							.zhezhao:hover {
								z-index: 99;
								background-color: transparent;
							}
						}
					}
				}
			}
		}

		.content {
			overflow: hidden;
			width: 1440px;
			height: 560px;
			margin: 0 auto;
			display: flex;

			div {
				width: 360px;
				height: 560px;
				text-align: center;

				img {
					display: block;
					margin: 0 auto;
					margin-top: 240px;
				}

				p {
					width: 360px;
					height: 58px;
					font-size: 26px;
					font-weight: 500;
					color: #ffffff;
					line-height: 58px;
				}
			}

			.zhengfu {
				background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/zhengfuBg.png) no-repeat;
				background-size: cover;
			}

			.yiliao {
				background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/yiliaoBg.png) no-repeat;
				background-size: cover;
			}

			.dianshang {
				background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/dianshangBg.png) no-repeat;
				background-size: cover;
			}

			.dichan {
				background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/dichanBg.png) no-repeat;
				background-size: cover;
			}
		}
	}

	.team {
		width: 1440px;
		height: 820px;
		margin: 0 auto;

		h3 {
			width: 1440px;
			height: 100px;
			text-align: center;
			font-size: 36px;
			font-weight: 500;
			color: #000000;
			line-height: 100px;
			margin: 58px auto;
		}

		.content {
			width: 1440px;
			height: 520px;
			display: flex;
			justify-content: space-around;
			align-items: center;
			overflow: hidden;

			div {
				width: 350px;
				height: 500px;
				box-sizing: border-box;

				img {
					display: block;
					margin: 0 auto;
					margin-top: 100px;
				}

				h5 {
					width: 100%;
					height: 80px;
					line-height: 80px;
					font-size: 26px;
					text-align: center;
					font-weight: 500;
					color: #000000;
				}

				p {
					width: 80%;
					height: 30px;
					margin: 0 auto;
					line-height: 30px;
					text-align: center;
					font-size: 16px;
					font-weight: 400;
					color: #666666;
				}
			}

			div:hover {
				box-shadow: 1px 1px 20px 2px #7cc8f823;
			}
		}
	}

	.case {
		position: relative;
		width: 100%;
		height: 900px;
		background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/caseBg.png) no-repeat;
		background-size: cover;

		.anli {
			position: absolute;
			left: 50%;
			top: 0;
			bottom: 0;
			margin: auto;
			width: 50%;
			height: 672px;
			// background-color: red;
			overflow: hidden;
			display: flex;
			align-items: center;

			img:nth-child(1) {
				width: 322px;
				height: 672px;
			}

			img {
				width: 222px;
				height: 482px;
				display: block;
				margin: 0 20px;
			}
		}

		.yinying {
			position: absolute;
			bottom: 0;
			width: 100%;
			height: 22px;
			background-color: rgba(0, 0, 0, 0.052);
		}

		.content {
			position: relative;
			width: 1440px;
			height: 100%;
			// background-color: #709db9;
			margin: 0 auto;
			overflow: hidden;

			h3 {
				height: 50px;
				line-height: 50px;
				font-size: 40px;
				font-weight: 500;
				color: #000000;
				margin-top: 200px;
			}

			p {
				height: 30px;
				width: 340px;
				line-height: 30px;
				font-size: 16px;
				font-weight: 400;
				color: #000000;
				margin-top: 30px;
			}

			button {
				display: block;
				width: 180px;
				height: 50px;
				margin-top: 80px;
				background: #fe0000;
				box-shadow: 0px 8px 32px 0px rgba(254, 0, 0, 0.16);
				border-radius: 25px;
				font-size: 16px;
				color: white;
			}
		}
	}

	.serve {
		width: 100%;
		height: 950px;
		overflow: hidden;
		background-color: #f2f6f9;

		h3 {
			width: 358px;
			height: 60px;
			margin: 0 auto;
			margin-top: 80px;
			text-align: center;
			line-height: 60px;
			font-size: 36px;
			font-weight: 500;
			color: #000000;
		}

		p {
			width: 358px;
			height: 50px;
			line-height: 50px;
			margin: 0 auto;
			margin-bottom: 50px;
			text-align: center;
			font-size: 16px;
			font-weight: 400;
			color: #000000;
		}

		.content {
			overflow: hidden;
			position: relative;
			width: 100%;
			height: 700px;

			.bg {
				display: block;
				margin: auto;
				width: auto;
				height: 680px;
				max-width: 100%;
				border: none;
				vertical-align: middle;
				overflow: hidden;
				transform: scale(1.2);
				transition: all 0.8s;
				transition-property: all;
				transition-duration: 0.8s;
				transition-timing-function: ease;
				transition-delay: 0s;
			}

			.bg:hover {
				transform: scale(1);
			}

			.dingzhi {
				display: block;
				position: absolute;
				background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/xcydzkfbg.png) no-repeat;
				background-size: cover;
				width: 788px;
				height: 444px;
				top: 0;
				right: 0;
				left: 0;
				bottom: 0;
				margin: auto;

				h3 {
					width: 100%;
					height: 40px;
					text-align: center;
					font-weight: 500;
					color: #ffffff;
				}

				p {
					width: 100%;
					height: 30px;
					font-size: 20px;
					font-weight: 400;
					color: #ffffff;
					line-height: 30px;
					text-align: center;
					margin-top: 20px;
				}

				h5 {
					width: 100%;
					height: 58px;
					font-size: 64px;
					font-weight: 400;
					color: #ffffff;
					line-height: 30px;
					text-align: center;
				}
			}
		}
	}

	.typepilot {
		height: 348px;
		width: 100%;
		background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/blueBg.png) no-repeat;
		background-size: cover;
		overflow: hidden;

		h3 {
			margin: 0 auto;
			text-align: center;
			margin-top: 80px;
			width: 700px;
			height: 34px;
			font-size: 36px;
			font-weight: 500;
			color: #ffffff;
			line-height: 34px;
		}

		p {
			width: 450px;
			height: 30px;
			margin: 0 auto;
			margin-top: 20px;
			text-align: center;
			font-size: 18px;
			font-weight: 400;
			color: #ffffff;
			line-height: 30px;
		}

		a {
			display: block;
			width: 236px;
			height: 64px;
			margin: 40px auto;
			line-height: 68px;
			background-color: #ebeef7;
			border-radius: 40px;
			font-size: 18px;
			font-weight: 500;
			color: #000099;
			box-shadow: 2px 2px 8px 2px rgba(245, 31, 31, 0.115);
			text-align: center;
			line-height: 64px;
		}
	}

	.service>div {
		overflow: hidden;
		width: 390px;
		height: 250px;
		margin: 20px 15px 10px 15px;
		border-radius: 5px;
		background-color: #f0f3fa;
		float: left;

		h5 {
			width: 200px;
			height: 40px;
			margin: 20px 0 0 20px;
			font-size: 30px;
			font-weight: 500;
			color: #000000;
			line-height: 40px;
		}

		.lable-box {
			width: 320px;
			height: 180px;
			margin: 20px 0 20px 20px;

			.lable {
				height: 30px;
				width: 70px;
				margin: 5px;
				line-height: 30px;
				font-size: 16px;
				text-align: center;
				border-radius: 14px;
				float: left;
				background-color: #ffffff;
			}
		}
	}

	// swiper
</style>